import React from "react";
import { SvgIcon } from "@mui/material";

function UploadIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.99984 12.0039C8.17665 12.0039 8.34622 11.9337 8.47124 11.8086C8.59626 11.6836 8.6665 11.5141 8.6665 11.3372L8.6665 4.27724L10.8598 6.47724C10.9854 6.60278 11.1556 6.6733 11.3332 6.6733C11.5107 6.6733 11.681 6.60278 11.8065 6.47724C11.932 6.3517 12.0026 6.18144 12.0026 6.00391C12.0026 5.82637 11.932 5.65611 11.8065 5.53057L8.47317 2.19724C8.41119 2.13475 8.33746 2.08516 8.25622 2.05131C8.17498 2.01747 8.08784 2.00004 7.99984 2.00004C7.91183 2.00004 7.82469 2.01747 7.74345 2.05131C7.66221 2.08516 7.58848 2.13475 7.5265 2.19724L4.19317 5.53057C4.13101 5.59273 4.0817 5.66652 4.04806 5.74774C4.01442 5.82895 3.99711 5.916 3.99711 6.00391C3.99711 6.09181 4.01442 6.17886 4.04806 6.26007C4.0817 6.34129 4.13101 6.41508 4.19317 6.47724C4.25533 6.5394 4.32912 6.58871 4.41034 6.62235C4.49155 6.65599 4.5786 6.6733 4.6665 6.6733C4.75441 6.6733 4.84145 6.65599 4.92267 6.62235C5.00388 6.58871 5.07768 6.5394 5.13984 6.47724L7.33317 4.27724L7.33317 11.3372C7.33317 11.5141 7.40341 11.6836 7.52843 11.8086C7.65346 11.9337 7.82302 12.0039 7.99984 12.0039Z"
          fill="#8E97A7"
        />
        <path
          d="M1.99984 14.3379L13.9998 14.3379C14.1766 14.3379 14.3462 14.2677 14.4712 14.1426C14.5963 14.0176 14.6665 13.848 14.6665 13.6712C14.6665 13.4944 14.5963 13.3248 14.4712 13.1998C14.3462 13.0748 14.1766 13.0046 13.9998 13.0046L1.99984 13.0046C1.82303 13.0046 1.65346 13.0748 1.52843 13.1998C1.40341 13.3248 1.33317 13.4944 1.33317 13.6712C1.33317 13.848 1.40341 14.0176 1.52843 14.1426C1.65346 14.2677 1.82303 14.3379 1.99984 14.3379Z"
          fill="#8E97A7"
        />
      </svg>
    </SvgIcon>
  );
}

export default UploadIcon;
